// Expected JSON structure from S3 citation codes file
export interface CitationCodeJson {
  code: string;
  description: string;
}

// Select option format for Ant Design Select component
export interface CitationCodeOption {
  value: string;
  label: string;
  title: string;
}

// Parse citation codes JSON array from S3 into Select options format.
export const parseCitationCodes = (
  json?: CitationCodeJson[],
): CitationCodeOption[] => {
  if (!Array.isArray(json)) return [];

  return json.map(({ code, description }) => ({
    value: code,
    label: `${code} - ${description}`,
    title: description || code,
  }));
};
